import SideNavEntryMapping from './SideNavEntryMapping'
export default {
    ENTRY_LIST: [
        {
            sectionTitle: 'Hotel Data',
            icon: 'home',
            data: [
                SideNavEntryMapping.HOTEL_INFO,
                SideNavEntryMapping.CONTACTS,
                SideNavEntryMapping.HOTEL_TEXT,
                SideNavEntryMapping.HOTEL_CONTENT,
                SideNavEntryMapping.HOTEL_POLICIES,
                SideNavEntryMapping.HOTEL_CHARGES,
                SideNavEntryMapping.EXTRA_CHARGES,
                SideNavEntryMapping.HOTEL_AMENITIES,
                SideNavEntryMapping.HOTEL_DESTINATIONS
            ]
        },
        {
            sectionTitle: 'Rooms',
            icon: 'bed',
            data: [
                SideNavEntryMapping.ROOM_TYPES,
                SideNavEntryMapping.MEETING_ROOMS,
                SideNavEntryMapping.HOTEL_CLOSEOUT,
            ]
        },
        {
            sectionTitle: 'Rates',
            icon: 'dollar',
            data: [
                SideNavEntryMapping.BASE_RATE_PLAN,
                SideNavEntryMapping.RATE_PLANS
            ]
        },
        {
            sectionTitle: 'Submit',
            icon: 'flag',
            data: [
                SideNavEntryMapping.SUBMIT_FOR_REVIEW
            ]
        }
    ]
}
